import { Types } from '@jumpcloud/ui-components';
import Constants from 'client/util/Constants';

const { Column } = Types;
const { dataNotAvailable } = Constants;

/**
 * Leaving this file local to this directory to see how it
 * expands as we build out the PKI section.
 *
 * @todo look at consolidating this file in the future
 *
 * Text for the empty/zero state card
 */
export const pkiGettingStartedCard = {
  title: 'Lifecycle Management',
  text: 'Allows the mapping of users, devices, and certificates based on groups. The mapping is preserved for future lifecycle management of JumpCloud certificate functions.',
  helpIcon: 'info',
  helpText: 'We recommend creating PKI specific user groups prior to mapping certificates.',
  buttonLabel: 'Create Mapping',
};

/**
 * Helpers to build filters for the certificate list
 */
export const pkiCertQuickFilters = [
  { name: 'Expiring Soon', value: 'filter1' },
  { name: 'Hide Revoked', value: 'filter2' },
  { name: 'Resource: RADIUS', value: 'filter3' },
];

/**
 * Certificate Statuses
 */
export const pkiCertStatusTypes = {
  expired: 'expired',
  revoked: 'revoked',
  valid: 'valid',
};

export const pkiCertStatusBadgeMap = {
  [pkiCertStatusTypes.expired]: 'inactive',
  [pkiCertStatusTypes.revoked]: 'error',
  [pkiCertStatusTypes.valid]: 'success',
};

/**
 * All Certificates Tables Columns
 */
export const pkiCertificateColumns = [
  Object.assign(Column({
    dataFieldName: 'certificateType',
    label: 'Certificate Type',
    sortable: true,
    visible: true,
  }), {
    getValue: item => `${item.certificateType[0].toUpperCase() + item.certificateType.slice(1)} Certificate`,
  }),
  Object.assign(Column({
    dataFieldName: 'name',
    label: 'User',
    sortable: true,
    visible: true,
  }), {
    getValue: item => `${item.firstname} ${item.lastname}`,
  }),
  Object.assign(Column({
    dataFieldName: 'deviceName',
    label: 'Device',
    sortable: true,
    visible: true,
  }), {
    getValue: item => item.deviceName || dataNotAvailable,
  }),
  Object.assign(Column({
    dataFieldName: 'deviceOs',
    label: 'Device OS',
    sortable: true,
    visible: true,
  }), {
    getValue: item => item.deviceOs || dataNotAvailable,
  }),
  Column({
    dataFieldName: 'startDate',
    label: 'Start Date',
    sortable: true,
    visible: true,
  }),
  Column({
    dataFieldName: 'endDate',
    label: 'End Date',
    sortable: true,
    visible: true,
  }),
  Column({
    dataFieldName: 'status',
    label: 'Status',
    sortable: true,
    visible: true,
  }),
  Column({
    dataFieldName: 'icon',
    label: '',
    visible: true,
    alignment: 'right',
  }),
];

export default {
  pkiCertQuickFilters,
  pkiCertStatusBadgeMap,
  pkiCertStatusTypes,
  pkiGettingStartedCard,
  pkiCertificateColumns,
};
